var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 0H2.9C1.58 0 0.512 1.04516 0.512 2.32258L0.5 16.2581C0.5 17.5355 1.58 18.5806 2.9 18.5806H22.1C23.42 18.5806 24.5 17.5355 24.5 16.2581V2.32258C24.5 1.04516 23.42 0 22.1 0ZM22.1 16.2581H2.9V4.64516L12.5 10.4516L22.1 4.64516V16.2581ZM12.5 8.12903L2.9 2.32258H22.1L12.5 8.12903Z",
    fill: "#039ECC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/Envelop.615dab6f23ff2e17c9f6927503d57503.svg";
export { ForwardRef as ReactComponent };